import React, {useState, useEffect} from 'react'
import Header from '../../layouts/Header'
import { Button, Card, Col, Dropdown, Form, Modal, Row, Spinner, Table } from 'react-bootstrap';
import CardHeader from 'react-bootstrap/esm/CardHeader';
import { toast } from 'react-toastify';
import axiosInstance from '../../api/axios';import { PencilFill, TrashFill } from 'react-bootstrap-icons';
import ReusableTable from '../../components/ReusableTable';

const AssetType = () => {

    const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
    const [skin, setSkin] = useState(currentSkin);

    const accessToken = localStorage.getItem("authToken");
    const [title, setTitle] = useState('');
    const [updateTitle, setUpdateTitle] = useState('');
    const [openAddModal, setOpenAddModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState('');
    const [assetType, setAssetType] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [isEditBtnLoading, setIsEditBtnLoading] = useState(false);
    const [errors2, setErrors2] = useState('');
    const [searchText, setSearchText] = useState('');
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [assetTypeId, setAssetTypeId] = useState('');
    const [isDeleteBtnLoading, setIsDeleteBtnLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const columns = [
      { header: "Sr.No", accessor: "serialNumber" },
      { header: "Title", accessor: "title" },
      { header: <div className="text-center">Actions</div>, accessor: null, render: (_, row) => (
            <div className="d-flex justify-content-center align-items-center">
              <Button
                variant="link"
                className="text-primary p-0 mx-2"
                onClick={() => handleOpenEditModal(row)}
                title="Edit"
              >
                EDIT <PencilFill size={16} /> {/* React-Bootstrap Icon for Edit */}
              </Button>
              <Button
                variant="link"
                className="text-danger p-0 mx-2"
                onClick={() => handleOpenDeleteModal(row)}
                title="Delete"
              >
                DELETE <TrashFill size={16} /> {/* React-Bootstrap Icon for Delete */}
              </Button>
            </div>
          )
      },
    ];

    const handleOpenAddModal = (e) => {
      setOpenAddModal(true);
    }

    const handleCloseAddModal = () => {
      setOpenAddModal(false);
      setTitle('');
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setTitle(value);
    }

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setUpdateTitle((prevState) => ({ ...prevState, [name]: value }));
    }

    const addAssetType = async(e) => {
        e.preventDefault();
        if( validateForm() ) {
          setIsLoading(true);
          try {
            const headers = {
              Authorization: `Bearer ${accessToken}`,
            };
    
            const inputData = {
              title: title,
            };
            const response = await axiosInstance.post("asset-type", inputData, { headers });
            
            if (response?.data?.status === true) {
              toast.success(response?.data?.data?.message, {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
              });
              getAssetType();
              setOpenAddModal(false);
              setTitle("");
            }
          } catch (error) {
            if (error?.response) {
              let errorMessage = '';
              if (
                error.response?.status === 406
              ) {
                errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
              }
              else if (
                error.response?.status === 412
              ) {
                errorMessage = error?.response?.data?.data?.message;
              } else if (error.response?.status === 500) {
                errorMessage = error?.response?.data?.error
              }
    
              toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
              });
            }
          } finally {
            setIsLoading(false);
          }
        }
    }

    const editAssetTypeSubmit = async(e) => {
        e.preventDefault();
        if ( validateForm2() ) {
          setIsEditBtnLoading(true);
          try {
            const headers = {
              Authorization: `Bearer ${accessToken}`,
            };
            const response = await axiosInstance.put("asset-type", updateTitle, { headers });
            if (response?.data?.status === true) {
              toast.success(response?.data?.data?.message, {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
              });
              getAssetType();
              setOpenEditModal(false);
            }
          } catch (error) {
            if (error?.response) {
              let errorMessage = '';
              if ( error.response?.status === 406 ) {
                errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
              }
              else if ( error.response?.status === 412 ) {
                errorMessage = error?.response?.data?.data?.message;
              } else if (error.response?.status === 500) {
                errorMessage = error?.response?.data?.error
              }
              toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
                theme: "colored",
              });
            }
          } finally {
            setIsEditBtnLoading(false);
          }
        }
    };

    const getAssetType = async() => {
        try {
          const headers = {
            Authorization: `Bearer ${accessToken}`,
          };
          const response = await axiosInstance.get("asset-type", { headers });
          response.data?.data?.assetTypes.forEach((item, index) => {
            item.serialNumber = index + 1;
          });
          setAssetType(response.data?.data?.assetTypes);
          setFilteredData(response.data?.data?.assetTypes);
          console.log("Response :", response);
          
        } catch (error) {
          if (error.response && error.response?.data?.status === false) {
            let errorMessage = error.response.data.error;
            toast.error(errorMessage, {
              position: "top-right",
              autoClose: 3000,
              theme: "colored",
            });
          }
        }
    }

    const handleOpenEditModal = (data) => {
        console.log("Edited Data :", data);
        
        setUpdateTitle({
            _id: data?._id,
            title: data.title,
          })
        setOpenEditModal(true);
    }

    const handleCloseEditModal = () => {
        setOpenEditModal(false);
    }

    const handleOpenDeleteModal = (data) => {
      setOpenDeleteModal(true);
      setAssetTypeId(data?._id);
    }

    const handleCloseDeleteModal = (data) => {
      setOpenDeleteModal(false);
    }

    const handleDeleteAssetType = async(e) => {
      e.preventDefault();
      setIsDeleteBtnLoading(true);
      try {
        const headers = {
          Authorization: `Bearer ${accessToken}`,
        };
  
        const data = {
          _id: assetTypeId,
        };
  
        const response = await axiosInstance.delete("asset-type", { data, headers });
        if (response?.data?.status === true) {
          toast.success(response?.data?.data?.message, {
            position: "top-right",
            autoClose: 3000,
            theme: "colored",
          });
          getAssetType();
          setOpenDeleteModal(false);
        }
      } catch (error) {
        if (error.response.status === 403) {
          toast.error(error?.response?.data?.message, {
            position: "top-right",
            autoClose: 3000,
            theme: "colored",
          });
        }
  
        if (error.response && error.response?.data?.status === false) {
          let errorMessage = error.response.data.error;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 3000,
            theme: "colored",
          });
        }
      } finally {
        setIsDeleteBtnLoading(false);
      }
    }

    const handleSearchChange = (e) => {
      setSearchText(e.target.value);
    }

    const validateForm = () => {
        const newErrors = {};
        const trimmedTitle = title.trim();
        const wordCount = trimmedTitle.split(/\s+/).length;
        const specialCharacterPattern = /[!@#$%^&*(),.?":{}|<>]/;
    
        if (!title || trimmedTitle.length === 0) { // Check if the title is empty or only contains spaces
            newErrors.title = "Title is required and cannot be empty or only spaces";
        } else if (!isNaN(title) || /^-\d+$/.test(title)) {
            newErrors.title = "Title should not contain numeric or a negative integer";
        } else if (trimmedTitle.length < 2) { // Check if title has at least 2 letters
            newErrors.title = "Title must contain at least 2 letters";
        } else if (specialCharacterPattern.test(title)) {
            newErrors.title = "Title should not contain special characters";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    }

    const validateForm2 = () => {
        let title = updateTitle?.title;
        const newErrors = {};
        const trimmedTitle = title ? title.trim() : '';
        const wordCount = trimmedTitle.split(/\s+/).length;
        const specialCharacterPattern = /[!@#$%^&*(),.?":{}|<>]/;
    
        if(!title || trimmedTitle.length === 0) { // Check if the title is empty or only contains spaces
          newErrors.title = "Title is required and cannot be empty or only spaces";
        } else if (!isNaN(title) || /^-\d+$/.test(title)) {
          newErrors.title = "Title should not contain numeric or a negative integer";
        } else if (trimmedTitle.length < 2) {
          newErrors.title = "Title must contain at least 2 letters";
        } else if (specialCharacterPattern.test(title)) {
          newErrors.title = "Title should not contain special characters";
        }
        setErrors2(newErrors);
        return Object.keys(newErrors).length === 0;
    }

    const handlePageChange = (page) => {
      setPage(page);
    };

    const handleRowsPerPageChange = (rowsPerPage) => {
      setPage(1);
      setRowsPerPage(rowsPerPage);
    };

    const getPaginatedData = () => {
      const startIndex = (page - 1) * rowsPerPage;
      
      const endIndex = startIndex + rowsPerPage;

      return filteredData?.slice(startIndex, endIndex);
    };

    useEffect(() => {
        getAssetType();
    }, []);

    useEffect(() => {
      const result = assetType.filter((item) => {
        return item.title?.toLowerCase().match(searchText.toLocaleLowerCase());
      });
      setFilteredData(result);
    }, [searchText]);

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className="main main-app p-3 p-lg-4">

                <div
                  className="container shadow-sm"
                  style={{ backgroundColor: "white" }}
                >
                  <Row className="pt-4">
                    <Col>
                        <h5 className="fw-semibold">Asset Type</h5>
                    </Col>
                    <hr />
                  </Row>
              
                  <Row className='mb-3 justify-content-between'>
                    <Col lg="8">
                      <div className="input-group w-50">
                        <input
                          type="text"
                          className="form-control"
                          value={searchText}
                          onChange={handleSearchChange}
                          placeholder="Search for roles..."
                        />
                        <button className="btn btn-primary" type="button">
                          <i className="ri-search-line"></i> {/* Search Icon */}
                        </button>
                      </div>
                    </Col>
                    <Col lg="3" className='text-end'>
                      <Button
                          variant="primary"
                          onClick={handleOpenAddModal}
                          className="fw-semibold"
                      >
                          <i className="ri-add-line" style={{ marginRight: '5px' }}></i>
                          Add New Asset Type
                      </Button>
                    </Col>
                  </Row>
  
                  <Row>
                    <Col lg="12">
                      <ReusableTable 
                        columns={columns} 
                        data={getPaginatedData()} 
                        rowKey="serialNumber"
                        currentPage={page}
                        recordsPerPage={rowsPerPage}
                        onPageChange={handlePageChange}
                        totalPages={Math.ceil(filteredData.length / rowsPerPage)}
                        onRecordsPerPageChange={handleRowsPerPageChange}
                      />
                    </Col>
                  </Row>
                </div>

                {/* <-------------- Add Asset Type Modal --------------> */}
                <Modal show={openAddModal} onHide={handleCloseAddModal} size='md' centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Add Asset Type</Modal.Title>
                    </Modal.Header>
                    <Form onSubmit={addAssetType}>
                        <Modal.Body>
                            <Form.Group controlId="formCategoryName">
                                <Form.Label className='fw-semibold'>Title <span className='text-danger'>*</span></Form.Label>
                                <Form.Control
                                    name="title"
                                    className="form-control"
                                    value={title}
                                    type="text"
                                    placeholder="Enter Title"
                                    onChange={handleChange}
                                />
                                {/* {errors2?.title && <div className='text-danger' style={{ fontSize : "12px"}}>{errors2?.title}</div>} */}
                            </Form.Group>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button type='submit'>
                                {
                                    isLoading ?
                                    <Spinner 
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    /> : "Add New Asset Tyepe"
                                }
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal>

                {/* <-------------- Edit Asser Type Modal --------------> */}
                <Modal show={openEditModal} onHide={handleCloseEditModal} size='md' centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Edit Asset Type</Modal.Title>
                    </Modal.Header>
                    <Form onSubmit={editAssetTypeSubmit}>
                        <Modal.Body>
                            <Form.Group controlId="formCategoryName">
                                <Form.Label className='fw-semibold'>Asset Type</Form.Label>
                                <Form.Control
                                    name="title"
                                    className="form-control"
                                    value={updateTitle?.title}
                                    type="text"
                                    placeholder="Enter Asset Type"
                                    onChange={handleEditChange}
                                />
                                {errors2?.title && <div className='text-danger' style={{ fontSize : "12px"}}>{errors2?.title}</div>}
                            </Form.Group>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button type='submit'>
                                {
                                    isEditBtnLoading ?
                                    <Spinner 
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    /> : "Save Changes"
                                }
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal>

                {/* <---------------- Delete Asset Type Modal ------------> */}
                <Modal show={openDeleteModal} onHide={handleCloseDeleteModal} centered>
                    <Modal.Header closeButton>
                        <Modal.Title className='text-danger'>Confirm Delete</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Are you sure you want to delete this Asset Type? This action cannot be undone.
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseDeleteModal}>
                            Cancel
                        </Button>
                        <Button variant="danger" onClick={handleDeleteAssetType}>
                            { isDeleteBtnLoading ?
                                <Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                /> :
                                "Delete Category"                                
                            }
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </React.Fragment>
    )
}

export default AssetType